export default __webpack_public_path__ + "static/media/khelp_logo.5841e22f.png";